export default {
    title: 'Massengenehmigung',

    maxProcessesForMassApproval: 'Es werden nur die ersten 1000 Vorgänge berücksichtigt.',
    massApprovalNotAvailableForProcesses: 'Für die folgenden Vorgänge ist die Massengenehmigung nicht verfügbar, da der Status des Vorgangs nicht in den Status, der genehmigte oder abgelehnte Vorgänge markiert, überführt werden kann:<br>{processes}.<br><br>Erlaubte Status: {allowedStatuses}.',

    startMassApproval: 'Massengenehmigung starten',
    errorOnStartingMassApproval: 'Fehler beim Starten der Massengenehmigung',
}